import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/emailDuplicate/user.emailDuplicate.merge.mutation.gql"
import type {
  UserEmailDuplicateMergeMutation,
  UserEmailDuplicateMergeMutationVariables,
} from "@/v2-backoffice-client/user/emailDuplicate/__types__/user.emailDuplicate.merge.mutation"

type Options = MutationHookOptions<
  UserEmailDuplicateMergeMutation,
  UserEmailDuplicateMergeMutationVariables
>

export function useUserEmailDuplicateMergeMutation(options?: Options) {
  return useMutation<
    UserEmailDuplicateMergeMutation,
    UserEmailDuplicateMergeMutationVariables
  >(mutation, options)
}
